import { Outlet } from "react-router-dom"

import { AppSidebar } from "@/components/AppSidebar"
import { DocumentationSheetProvider } from "@/components/DocumentationSheetContext"
import { GlobalHotkeys } from "@/components/GlobalHotkeys"
import { HotkeysHelpDialog } from "@/components/HotkeysHelpDialog"
import { SiteHeader } from "@/components/SiteHeader"
import { ThemeProvider } from "@/components/theme-provider"
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar"
import { Toaster } from "@/components/ui/sonner"
import { HardwareScannerListener } from "@/components/HardwareScannerListener"
import { QuickActionsFab } from "@/components/QuickActionsFab"
import { HotkeysProvider } from "@/lib/hotkeys"

export function Layout() {
  return (
    <ThemeProvider defaultTheme="system" storageKey="vite-ui-theme">
      <DocumentationSheetProvider>
        <HotkeysProvider>
          <SidebarProvider className="bg-background">
            <AppSidebar />
            <SidebarInset>
              <SiteHeader />
              <div className="flex flex-1 flex-col gap-4 p-4 pt-0">
                <Outlet />
              </div>
            </SidebarInset>
            <HardwareScannerListener />
            <QuickActionsFab />
            <GlobalHotkeys />
            <HotkeysHelpDialog />
            <Toaster richColors />
          </SidebarProvider>
        </HotkeysProvider>
      </DocumentationSheetProvider>
    </ThemeProvider>
  )
}
